import type { WalletsTranslations } from "../interfaces/wallets";

export const walletsTranslations: WalletsTranslations = {
  page_eyebrow: "My wallets",
  page_title_with_name: "{{name}}'s wallets",
  page_subtitle: "{{count}} active",
  export_balance_button: "Export balance",
  stat_usd_equivalent: "USD equivalent",
  stat_active_countries: "Active countries",
  stat_crypto_networks: "Crypto networks",
  stat_open_movements: "Open movements",
  section_active: "Active",
  section_active_sub: "You can already operate in these currencies",
  card_status_active: "ACTIVE",
  card_status_frozen: "FROZEN",
  card_status_closed: "CLOSED",
  card_available_label: "Available",
  card_frozen_reason_label: "Reason",
  card_frozen_banner_title: "New operations blocked",
  card_actions_aria: "Wallet actions",
  card_menu_movements: "View movements",
  operation_link_opening: "Opening the movement in your wallet…",
  card_menu_top_up: "Top up",
  card_methods_label: "Top-up and send methods",
  card_methods_crypto: "Top-up and withdrawal networks",
  card_recent_activity: "Recent activity",
  card_recent_empty: "No recent movements.",
  card_view_all: "View all",
  card_action_load: "Receive money",
  card_action_send: "Send money",
  card_action_receive_short: "Receive",
  card_action_send_short: "Send",
  card_action_convert: "Convert",
  card_action_pay_qr: "Pay with QR",
  entry_payin_detected_wallet: "Collection on its way",
  entry_payin_confirmed_wallet: "Collection credited",
  entry_payout_reserve_wallet: "Money sent",
  entry_payout_release_wallet: "Transfer returned",
  entry_swap_wallet: "Wallet-to-wallet conversion",
  entry_coloca_top_up_wallet: "Top-up from Coloca Payments",
  card_action_load_unavailable:
    "This corridor is not enabled for your organization yet. Reach out to your account executive.",
  card_action_send_unavailable: "Sending not available for this currency",
  activate_cta: "Activate wallet",
  activate_title: "Activate wallet",
  activate_subtitle: "Choose the currency to activate a new wallet.",
  activate_currency_label: "Currency",
  activate_currency_placeholder: "Select a currency",
  activate_loading: "Loading currencies…",
  activate_confirm: "Activate",
  activate_cancel: "Cancel",
  activate_success: "Wallet activated.",
  activate_error: "We couldn't activate the wallet.",
  activate_all_active: "You've already activated every available currency.",
  card_menu_delete: "Delete wallet",
  order_cta: "Reorder",
  order_title: "Arrange your wallets",
  order_subtitle: "Drag them or use the arrows. Your whole team sees them in this order.",
  order_move_up_aria: "Move {{currency}} up",
  order_move_down_aria: "Move {{currency}} down",
  order_moved_announcement: "{{currency}} is now in position {{position}}.",
  order_save: "Save order",
  order_cancel: "Cancel",
  order_saved: "Order saved.",
  order_save_error: "We couldn't save the order.",
  delete_title: "Delete the {{currency}} wallet?",
  delete_desc: "It has no balance and no movements, so nothing is lost.",
  delete_point_list: "It leaves your list of wallets.",
  delete_point_reactivate: "You can activate it again any time from “Activate wallet”.",
  delete_point_incoming: "If money arrives in {{currency}}, it comes back on its own.",
  delete_confirm: "Delete wallet",
  delete_cancel: "Cancel",
  delete_success: "Wallet deleted. You can activate it again any time.",
  delete_error: "We couldn't delete the wallet.",
  empty_activate_title: "You don't have any active wallets yet.",
  empty_activate_desc: "Activate your first wallet to start receiving and sending money.",
  empty_activate_cta: "Activate your first wallet",
  reader_title: "Wallets by organization",
  reader_subtitle: "Select an organization to view its wallets.",
  reader_search_placeholder: "Search organization…",
  reader_change_org: "Change organization",
  reader_no_orgs: "No organizations found.",
  reader_org_wallets_empty: "This organization has no active wallets.",
  overview_title: "Client wallets",
  overview_subtitle: "How much Coloca must back in each currency, and who holds it.",
  overview_updated: "Updated {{time}}",
  overview_refresh: "Refresh",
  overview_include_coloca: "Include Coloca",
  overview_include_coloca_hint:
    "Also adds Coloca Payments' own wallets, which hold Coloca's money rather than a client's.",
  overview_activate_for_org: "Activate for an organization",
  overview_back: "Back to the overview",
  summary_held: "To back",
  summary_available: "Available",
  summary_blocked: "Blocked",
  summary_pending: "To be confirmed",
  summary_wallets: "{{funded}} of {{wallets}} with a balance",
  summary_top_holder: "Largest: {{name}} · {{share}}",
  summary_select_aria: "Show only the {{currency}} wallets",
  summary_footnote:
    "To back = available + blocked (payouts under way that have not left yet). “To be confirmed” are detected collections that have not arrived yet, and are not added.",
  summary_empty: "No wallets match these filters.",
  summary_error: "We could not add up the balances.",
  filter_search_label: "Organization",
  filter_search_placeholder: "Organization name, email or id",
  filter_currency_label: "Currency",
  filter_currency_all: "All currencies",
  filter_status_label: "Status",
  filter_status_all: "All statuses",
  status_active: "Active",
  status_frozen: "Frozen",
  status_closed: "Closed",
  filter_sort_label: "Sort by",
  sort_held_desc: "Most to back",
  sort_held_asc: "Least to back",
  sort_available_desc: "Most available",
  sort_pending_desc: "Most to be confirmed",
  sort_last_movement_desc: "Most recent movement",
  sort_created_desc: "Most recently activated",
  filter_with_balance: "With a balance only",
  filter_min_held: "To back from",
  filter_max_held: "Up to",
  filter_range_needs_currency: "Pick a currency to filter by amount.",
  filter_sort_grouped_hint:
    "With no currency picked, the order runs within each currency: amounts in different currencies are not compared.",
  filter_clear: "Clear filters",
  col_organization: "Organization",
  col_currency: "Currency",
  col_held: "To back",
  col_share: "% of the currency",
  col_status: "Status",
  col_last_movement: "Last movement",
  col_actions: "Actions",
  never_moved: "No movements",
  action_open_org: "View organization",
  table_total: "{{total}} wallets",
  table_empty: "No wallet matches these filters.",
  table_empty_desc: "Try another currency or turn off “With a balance only”.",
  table_empty_unfunded_one: "The matching wallet has no balance.",
  table_empty_unfunded_other: "The {{count}} matching wallets have no balance.",
  table_empty_unfunded_desc:
    "“With a balance only” leaves out wallets with no balance, and one may still have moved money: its statement shows it.",
  hidden_unfunded_note_one: "1 wallet with no balance is hidden by “With a balance only”.",
  hidden_unfunded_note_other: "{{count}} wallets with no balance are hidden by “With a balance only”.",
  hidden_unfunded_show: "Show wallets with no balance",
  rows_error: "We could not load the wallets.",
  tab_wallets: "Client wallets",
  tab_providers: "Provider balances",
  coverage_title: "Coverage by currency",
  coverage_hint: "What the wallets need backed against what the providers report holding.",
  coverage_label: "Coverage",
  coverage_held: "To back",
  coverage_in_providers: "At providers",
  coverage_short: "Short by",
  coverage_surplus: "Surplus of",
  coverage_nothing_to_back: "Nothing to back",
  coverage_no_reading: "No reading",
  coverage_partial: "Some balances in this currency could not be read.",
  providers_title: "By provider",
  providers_footnote:
    "Only what each provider reports through its API: vaults, bank accounts and other Coloca funds are not included.",
  providers_refresh: "Read again",
  providers_refresh_hint: "Asks every provider now instead of reusing a reading up to a minute old.",
  providers_refresh_denied: "Reading again needs payments write access. The latest readings are shown.",
  providers_empty: "No active route has a balance to read.",
  providers_error: "We could not read the provider balances.",
  float_col_account: "Account",
  float_col_available: "Available",
  float_col_status: "Status",
  float_col_read: "Read",
  float_use_payout: "{{rail}} payouts",
  float_use_payin: "{{rail}} collections not yet settled",
  float_status_OK: "Up to date",
  float_status_STALE: "Out of date",
  float_status_UNAVAILABLE: "No reading",
  float_status_UNSUPPORTED: "No balance API",
  recheck_running: "Checking the payouts in progress with the providers…",
  recheck_done:
    "Payouts in progress checked: {{settled}} paid, {{rejected}} rejected, {{stillOpen}} still in progress",
  recheck_none: "No payouts in progress to check",
  recheck_not_found: "{{count}} unknown to the provider (to review)",
  recheck_failed_some: "{{count}} could not be checked",
  recheck_failed: "We could not check the payouts in progress with the providers.",
  loading: "Loading wallets…",
  error_load: "We couldn't load your wallets.",
  retry: "Retry",
  refresh_aria: "Refresh balance",
  balance_hide_aria: "Hide balances",
  balance_show_aria: "Show balances",
  tx_status_process: "Processing",
  tx_op_payin: "Incoming",
  tx_op_payout: "Outgoing",
  tx_op_swap: "Swap",
  tx_op_fee: "Fee",
  tx_op_adjust: "Top-ups and adjustments",
  tx_op_coloca_top_up: "Top-up",
  tx_op_reverse: "Reversal",
  statement_pending_label: "Pending",
  statement_blocked_label: "Blocked",
  statement_filter_op_all: "All types",
  statement_filter_dir_all: "All directions",
  statement_filter_dir_credit: "Incoming",
  statement_filter_dir_debit: "Outgoing",
  pending_collections_title: "Pending collections",
  pending_collections_count_one: "1 collection",
  pending_collections_count_other: "{{count}} collections",
  pending_collections_awaiting: "Waiting for payment",
  pending_collections_not_found: "We could not open that collection. It may no longer exist.",
  pending_collections_dismiss: "Got it",
  statement_detail_date: "Date",
  statement_detail_type: "Type",
  statement_detail_rail: "Payment method",
  statement_detail_beneficiary: "Recipient",
  statement_detail_breb_key: "Bre-B key",
  statement_detail_breb_network_reference: "Bre-B transaction ID",
  statement_detail_direction: "Direction",
  statement_detail_amount: "Amount",
  statement_detail_balance_after: "Resulting balance",
  statement_detail_status: "Status",
  statement_detail_description: "Description",
  statement_detail_reference: "Reference",
  statement_detail_origin: "Origin",
  statement_detail_concept: "Concept",
  statement_detail_top_up_reference: "Top-up reference",
  statement_detail_reversal: "Reversal",
  statement_detail_reversal_yes: "Yes",
  statement_detail_view_ledger: "View journal entries",
  statement_filter_range: "Date range",
  statement_freeze: "Freeze",
  statement_unfreeze: "Unfreeze",
  statement_freeze_title_wallet: "Freeze {{currency}} wallet",
  statement_freeze_intro: "You are about to block new operations on this wallet.",
  statement_freeze_desc: "The wallet will reject new commitments but still complete in-flight operations.",
  statement_freeze_reason_label: "Reason",
  statement_freeze_reason_placeholder: "Reason for freezing",
  statement_freeze_confirm: "Freeze",
  statement_freeze_cancel: "Cancel",
  statement_freeze_success: "Wallet frozen.",
  statement_freeze_error: "We couldn't freeze the wallet.",
  statement_unfreeze_title_wallet: "Unfreeze {{currency}} wallet?",
  statement_unfreeze_clears_reason: "The recorded reason will be cleared:",
  statement_unfreeze_desc: "The wallet will accept operations again.",
  statement_unfreeze_success: "Wallet unfrozen.",
  statement_unfreeze_error: "We couldn't unfreeze the wallet.",
  // Colombia deposit modal
  deposit_modal_title: "Load funds",
  deposit_mode_received: "What I'll receive in my wallet",
  deposit_mode_sent: "Amount they'll transfer to me",
  deposit_amount_label: "How much do you want to load?",
  deposit_breakdown_title: "Estimated breakdown",
  deposit_breakdown_pays: "You will pay",
  deposit_breakdown_fee: "Estimated fee",
  deposit_breakdown_credited: "We credit approx.",
  deposit_continue: "Continue",
  deposit_edit_amount: "Edit amount",
  deposit_processing: "Processing your request…",
  deposit_result_error: "Could not create the payment",
  deposit_retry: "Try again",
  deposit_new: "Create another",
  deposit_close: "Close",
  deposit_nequi_open: "Open payment",
  deposit_copy_link: "Copy link",
  deposit_link_copied: "Link copied",
  deposit_breb_key_label: "Bre-B Key",
  deposit_copy_key: "Copy key",
  deposit_key_copied: "Key copied",
  deposit_result_fee_label: "Fee",
  deposit_result_fee_free: "Free",
  deposit_verify_cta: "I sent it, verify",
  deposit_verify_checking: "Checking…",
  deposit_verify_paid: "Payment received! Funds are on their way.",
  deposit_verify_pending: "Still processing. Try again in a few seconds.",
  deposit_verify_failed: "Payment not found or rejected.",
  // Brazil (PIX)
  deposit_pix_copia_label: "Pix Code (Copy & Paste)",
  deposit_pix_copy_code: "Copy code",
  deposit_pix_code_copied: "Code copied",
  // Colombia (Bre-B)
  // Colombia (PSE — bank-redirect debit). The payer form, the bank handoff and their failures now live in
  // the `payins` namespace (`pse_*`), shared with the Colombia tab of /app/payins; only the rows this modal
  // renders itself stay here.
  deposit_method_pse: "PSE",
  deposit_pse_bank_label: "Bank",
  deposit_pse_doc_number_label: "Document number",
  deposit_pse_confirmed: "Payment confirmed — the wallet balance was credited.",
  // Colombia (Nequi push)
  deposit_nequi_waiting_title: "Check the Nequi app",
  deposit_nequi_waiting_body:
    "We sent the charge request to {{phone}}. Accept the payment in the Nequi app to complete the deposit.",
  deposit_nequi_waiting_live: "Waiting for confirmation… you can keep this window open.",
  deposit_payer_name_label: "Payer name",
  deposit_payer_name_placeholder: "Full name",
  deposit_payer_doc_label: "Payer CPF/CNPJ",
  deposit_payer_doc_placeholder: "Digits only",
  deposit_payer_hint: "Details of the person making the PIX payment; required to generate the QR.",
  deposit_error_no_org: "Your user has no associated organization, the payment cannot be created.",
  // Mexico (SPEI/CLABE)
  deposit_clabe_label: "CLABE Account",
  deposit_spei_clabe_label: "CLABE for this charge",
  deposit_spei_hint:
    "Details of whoever will send the SPEI transfer. A CLABE is assigned to this charge alone, and it expires.",
  deposit_payer_rfc_label: "Payer RFC (optional)",
  deposit_payer_rfc_placeholder: "You can leave this empty",
  deposit_clabe_copy: "Copy CLABE",
  deposit_clabe_copied: "CLABE copied",
  deposit_expires_label: "Expires on",
  // Shared confirm / result
  deposit_payment_created: "Payment created",
  deposit_result_id: "ID",
  deposit_confirm_amount: "Amount",
  deposit_confirm_method_row: "Method",
  deposit_edit: "Edit",
  deposit_create_payment: "Create payment",
  deposit_you_receive: "You'll receive",
  deposit_payer_sends: "Payer sends",
  deposit_receive_label: "You want to receive",
  deposit_paid_title: "Payment received",
  deposit_paid_text: "The payer completed the transfer and the net amount is already in your wallet.",
  deposit_verify_reversed: "The payment was reversed: the credited amount was taken back from your wallet.",
  deposit_reversed_text:
    "This payment had been credited and was later reversed: the credited amount was taken back from your wallet. You can create a new deposit.",
  deposit_rejected_text: "The payment was rejected and nothing was credited. You can create a new deposit.",
  deposit_mode_gross_label: "I will pay",
  deposit_mode_net_label: "I want to receive",
  deposit_mode_gross_hint: "Type what you will transfer; we tell you what gets credited.",
  deposit_mode_net_hint: "Type what should be credited; we tell you what you must transfer.",
  deposit_derived_net_text:
    "{{amount}} {{currency}} is credited to your wallet, after a {{fee}} {{currency}} fee.",
  deposit_derived_gross_text:
    "You must transfer {{amount}} {{currency}} for it to be credited in full, with a {{fee}} {{currency}} fee.",
  deposit_pays: "You pay",
  deposit_we_credit: "We credit",
  deposit_confirm_name: "Name",
  // Colombia confirm section headers
  deposit_confirm_amount_method: "Amount and method",
  deposit_confirm_payer_data: "Payer details",
  // Colombia confirm row labels
  deposit_confirm_document: "Document",
  deposit_confirm_email_row: "Email",
  deposit_confirm_phone: "Phone",
  deposit_confirm_nequi: "Nequi",
  deposit_confirm_bank: "Bank",
  deposit_confirm_description: "Description",
  // Colombia form labels
  deposit_form_firstname: "First name",
  deposit_form_lastname: "Last name",
  deposit_form_doc_type: "Document type",
  deposit_form_doc_number: "Document number",
  deposit_form_email: "Email address",
  deposit_form_description: "Description",
  deposit_form_bank: "Bank",
  deposit_form_nequi: "Nequi number",
  // Colombia form placeholders
  deposit_form_firstname_placeholder: "John",
  deposit_form_lastname_placeholder: "Doe",
  deposit_form_description_placeholder: "Payment concept",
  deposit_form_bank_placeholder: "Select your bank",
  // Colombia method card
  deposit_method_filtered: "filtered by amount",
  // Colombia result screen
  deposit_nequi_section: "Open Nequi payment",
  deposit_nequi_blocked: "Your browser blocked the popup. Copy the link or try again.",
  // Wallet statement (movements) view
  movements_hero_balance_label: "Available balance",
  movements_stat_movement_singular: "movement",
  movements_stat_movement_plural: "movements",
  movements_filter_clear: "Clear",
  movements_group_today: "Today",
  movements_group_yesterday: "Yesterday",
  movements_empty_no_data: "This wallet doesn't have any movements yet.",
  movements_empty_no_results: "No results match the current filters.",
  movements_detail_label_external: "EXTERNAL",
  movements_detail_label_internal: "INTERNAL",

  deposit_back: "Back",
  deposit_amount_section_title: "Collect an amount",
  deposit_amount_section_hint:
    "Create a QR for a set amount, or collect through PSE, Nequi or Botón Bancolombia.",
  deposit_amount_input_label: "How much are you collecting?",
  deposit_fee_switch: "I'll cover the fee",
  deposit_fee_on_hint: "The payer sends the exact amount; the fee comes out of what reaches your wallet.",
  deposit_fee_off_hint: "You receive the full amount; the fee is added to what the payer sends.",
  deposit_row_fee: "Fee",
  deposit_row_credited: "Reaches your wallet",
  deposit_fee_free: "Free",
  deposit_amount_hint_bra: "The payer sends it over PIX from any bank in Brazil.",
  deposit_amount_hint_mex: "The payer sends it over SPEI from any bank in Mexico.",
  deposit_method_pix_hint: "Instant, with a QR or Pix Copia e Cola",
  deposit_method_spei_hint: "A transfer to a CLABE created for this collection only",
  deposit_payer_name_error: "Enter the payer's name",
  deposit_payer_doc_error: "Enter a CPF (11 digits) or a CNPJ (14 digits).",
  deposit_payer_doc_check_error: "Check the number: its check digits don't match.",
  deposit_payer_rfc_error: "An RFC has at most 13 characters.",
  deposit_payer_rfc_short: "RFC",
  deposit_how_to_pay: "How to pay",
  deposit_pix_waiting: "Waiting for the payment",
  deposit_pix_expires_in: "Expires in {{time}}",
  deposit_pix_expired_title: "This QR has expired",
  deposit_pix_expired_text: "It can no longer be paid. Create another collection for a new QR.",
  deposit_pix_step_1: "Open the banking app and go to Pix.",
  deposit_pix_step_2: "Scan the QR, or pick Pix Copia e Cola and paste the code.",
  deposit_pix_step_3: "Confirm the {{amount}} payment. We credit it as soon as it arrives.",
  deposit_spei_waiting: "Waiting for the transfer",
  deposit_spei_exact_amount: "Exact amount to transfer",
  deposit_spei_copy_amount: "Copy amount",
  deposit_spei_amount_copied: "Amount copied",
  deposit_spei_step_1: "In online banking, create a SPEI transfer.",
  deposit_spei_step_2: "Use this CLABE and transfer exactly {{amount}}.",
  deposit_spei_step_3: "We credit it as soon as it arrives. The CLABE only works for this collection.",
  deposit_processing_pix: "Generating your PIX QR…",
  deposit_processing_spei: "Generating the CLABE for this collection…",
  statement_detail_copy_link: "Copy link",
  statement_detail_link_copied: "Link copied",
  statement_detail_copy_link_error: "We could not copy the link. Copy the address from the browser.",
  statement_movement_not_found: "We could not find that movement in this wallet.",
  // WhatsApp notifications for money in and out (/app/wallets/notifications). Catalogue only for now.
  notifications_eyebrow: "Wallets · Collections and payouts",
  notifications_page_title: "WhatsApp notifications",
  notifications_page_subtitle:
    "Get a WhatsApp message when money comes into or leaves your wallets, without checking the activity: collections, payouts, batch payments and Bre-B.",
  notifications_hero_title: "Alerts when money comes in or goes out",
  notifications_hero_sub:
    "A message the moment a payment is credited or a payout is resolved, with the amount, the method and the reference.",
  notifications_footnote: "Alerts go to the number you set above, not to the payer or the beneficiary.",
  notifications_recipient_hint: "Sent to your organization's alert number",
  notifications_recipient_label: "Number that receives the alerts",
  notifications_recipient_help:
    "By default, the mobile of your organization's verification. Change it to get them on another number.",
  notifications_recipient_help_custom:
    "The number you saved. Clear it to go back to the mobile of your organization's verification.",
  notifications_recipient_missing:
    "Your organization has no phone on record. Type the number that will receive the alerts.",
  notifications_recipient_save: "Save number",
  notifications_threshold_label: "Alert when the balance drops below",
  notifications_threshold_help:
    "One threshold per wallet. You are alerted once when the balance drops below it, until it goes back up.",
  notifications_threshold_required_error: "Set at least one threshold above zero.",
  notifications_threshold_no_wallets: "Activate a wallet to set its threshold.",
  notifications_enable_confirm_title: "Turn on the «{{name}}» alert?",
  notifications_enable_confirm_intro:
    "Coloca will send this WhatsApp to your organization's alert number every time this happens:",
  notifications_enable_confirm_reversible: "You can turn it off at any time.",
  notifications_enable_confirm_button: "Yes, turn on",
  notifications_enable_confirm_cancel: "Cancel",

  notifications_group_collections_title: "Collections",
  notifications_group_collections_desc:
    "The other methods: PSE, Nequi, Botón Bancolombia, Transfiya, PIX, SPEI, CBU/CVU and USDT.",
  notifications_group_payouts_title: "Payouts",
  notifications_group_payouts_desc:
    "One-by-one payouts over PSE, Transfiya, PIX, SPEI, CBU/CVU or USDT, and the balance of the wallet that funds them.",
  notifications_group_batches_title: "Batch payouts",
  notifications_group_batches_desc:
    "Batches uploaded from a spreadsheet, from awaiting approval to finished.",
  notifications_group_breb_title: "Bre-B",
  notifications_group_breb_desc:
    "Payments you receive with your QR code or on your key, transfers to a Bre-B key and payments of merchants' Bre-B QR codes.",

  notifications_payin_confirmed_name: "Payment received",
  notifications_payin_confirmed_desc:
    "The payment was credited to your wallet, with what came in after the fee.",
  notifications_payin_rejected_name: "Payment not completed",
  notifications_payin_rejected_desc:
    "The bank rejected the payment or a different amount arrived. A QR or link that simply expires is not notified.",
  notifications_payout_paid_name: "Payout paid",
  notifications_payout_paid_desc:
    "The bank or network confirmed the money reached the beneficiary. Sends one message per payout.",
  notifications_payout_failed_name: "Payout not completed",
  notifications_payout_failed_desc:
    "The beneficiary's bank rejected it or Coloca cancelled it. The money returns to your wallet.",
  notifications_wallet_balance_low_name: "Low balance",
  notifications_wallet_balance_low_desc:
    "A wallet balance dropped below the threshold you set, so you can top it up before your payouts stop.",
  notifications_batch_pending_name: "Batch awaiting approval",
  notifications_batch_pending_desc:
    "Someone in your organization sent a batch for approval, and a second person has to approve it.",
  notifications_batch_completed_name: "Batch processed",
  notifications_batch_completed_desc:
    "The batch finished running, with how many payouts went out and how many failed.",
  notifications_breb_payment_name: "Payment received over Bre-B",
  notifications_breb_payment_desc:
    "Someone paid with your QR code or to your key, and the money is already in your wallet.",
  notifications_breb_paid_name: "Bre-B transfer completed",
  notifications_breb_paid_desc: "The recipient's bank confirmed the transfer, with the key and the holder.",
  notifications_breb_failed_name: "Bre-B transfer not completed",
  notifications_breb_failed_desc:
    "The key does not exist, is inactive or the recipient's bank rejected it. The money returns to your COP wallet.",
  notifications_breb_qr_payment_name: "Bre-B QR payment",
  notifications_breb_qr_payment_desc: "Your organization paid a merchant's Bre-B QR code from Coloca.",

  notifications_bubble_payin_confirmed_body:
    "Recibiste COP 1.250.000 por PSE.\nEmpresa: Tienda Viva SAS\nPagador: Laura Gómez Ríos\nAbonado a tu billetera: COP 1.241.250\n6 oct 2026 · 2:30 p. m. · Ref. 7F3A9C21\n\nYa está disponible en tu billetera.",
  notifications_bubble_payin_rejected_body:
    "Un pago de COP 480.000 por PSE no se completó.\nEmpresa: Tienda Viva SAS\nMotivo: El banco del pagador rechazó la transacción\nPagador: Carlos Pérez\n6 oct 2026 · 3:05 p. m. · Ref. C41D0B7E\n\nNo se abonó a tu billetera. Si tienes dudas, escríbenos por aquí.",
  notifications_bubble_payout_paid_body:
    "Tu envío de BRL 1.500,00 por PIX fue pagado.\nEmpresa: Tienda Viva SAS\nBeneficiario: Ana Souza\nDestino: Llave PIX •••• 8899\n6 oct 2026 · 11:20 a. m. · Ref. 9B12E0F4\n\nEl beneficiario ya recibió el dinero.",
  notifications_bubble_payout_failed_body:
    "Tu envío de COP 900.000 por Transfiya no se completó.\nEmpresa: Tienda Viva SAS\nMotivo: El banco o la red del beneficiario rechazó el envío\nBeneficiario: Jorge Ramírez\n6 oct 2026 · 4:10 p. m. · Ref. 2D7C55A0\n\nEl dinero volvió a tu billetera COP. Si tienes dudas, escríbenos por aquí.",
  notifications_bubble_wallet_balance_low_body:
    "Tu billetera COP bajó de COP 5.000.000.\nEmpresa: Tienda Viva SAS\nSaldo disponible: COP 3.250.000\n6 oct 2026 · 4:45 p. m.\n\nRecárgala para que tus próximos envíos no se detengan.",
  notifications_bubble_batch_pending_body:
    "El lote nomina-octubre-2026.xlsx espera aprobación.\nEmpresa: Tienda Viva SAS\nPagos: 120 · Total: COP 98.400.000\nMedio: Bre-B\nEnviado por: Andrés Molina\n\nEntra a Coloca para revisarlo y aprobarlo.",
  notifications_bubble_batch_completed_body:
    "Terminó de procesarse el lote nomina-octubre-2026.xlsx.\nEmpresa: Tienda Viva SAS\nEnviados: 118 de 120 · Fallidos: 2\nTotal enviado: COP 96.760.000\n\nEn Coloca puedes ver el detalle y reintentar los fallidos.",
  notifications_bubble_breb_payment_body:
    "Recibiste COP 85.000 por Bre-B con tu código QR.\nEmpresa: Tienda Viva SAS\nPagador: Valentina Cruz\nAbonado a tu billetera: COP 84.405\n6 oct 2026 · 12:10 p. m. · Ref. 4E8A1D93\n\nYa está disponible en tu billetera.",
  notifications_bubble_breb_paid_body:
    "Tu transferencia de COP 350.000 por Bre-B fue exitosa.\nEmpresa: Tienda Viva SAS\nLlave destino: 300 ••• 4567\nTitular: Cami••• Rest•••\n6 oct 2026 · 9:42 a. m. · Ref. A0F3C7B2\n\nEl titular ya recibió el dinero.",
  notifications_bubble_breb_failed_body:
    "Tu transferencia de COP 120.000 a la llave @ferr••• no se completó.\nEmpresa: Tienda Viva SAS\nMotivo: La llave no existe, está inactiva o la entidad la rechazó\n6 oct 2026 · 10:05 a. m. · Ref. 6C2B90DE\n\nEl dinero volvió a tu billetera COP. Si tienes dudas, escríbenos por aquí.",
  notifications_bubble_breb_qr_payment_body:
    "Pagaste COP 46.900 a Panadería San José con un código QR Bre-B.\nEmpresa: Tienda Viva SAS\n6 oct 2026 · 8:15 a. m. · Ref. 5D1E7A08\n\nSe descontó de tu billetera COP.",
  notifications_bubble_payin_confirmed_title: "Pago recibido",
  notifications_bubble_payin_rejected_title: "Pago no completado",
  notifications_bubble_payout_paid_title: "Envío pagado",
  notifications_bubble_payout_failed_title: "Envío no completado",
  notifications_bubble_wallet_balance_low_title: "Saldo bajo",
  notifications_bubble_batch_pending_title: "Lote por aprobar",
  notifications_bubble_batch_completed_title: "Lote procesado",
  notifications_bubble_breb_payment_title: "Pago recibido por Bre-B",
  notifications_bubble_breb_paid_title: "Transferencia Bre-B exitosa",
  notifications_bubble_breb_failed_title: "Transferencia Bre-B no completada",
  notifications_bubble_breb_qr_payment_title: "Pago con QR Bre-B",
  entry_card_top_up: "Card top-up •••• {{last4}}",
  entry_card_top_up_reversal: "Card top-up returned •••• {{last4}}",
  tx_op_card_top_up: "Card top-up",
  tx_op_card_top_up_reversal: "Card top-up returned",
  statement_detail_card: "Card",
  statement_detail_card_open: "View card",
  statement_detail_card_credited: "Reached the card",
  statement_detail_card_price: "Price per dollar",
  tab_movements: "Movements",
  movements_presets_label: "Quick views",
  movements_preset_breb_paid: "Paid Bre-B",
  movements_preset_otc_processing: "OTC in progress",
  movements_preset_open_incidents: "Open incidents",
  movements_filter_search: "Search",
  movements_filter_search_placeholder: "Organization, beneficiary, key, id or reference (NOV-, CP-…)",
  movements_filter_organization: "Organization",
  movements_filter_organization_all: "All organizations",
  movements_filter_organization_all_hint: "Movements of every organization.",
  movements_filter_min: "Amount from",
  movements_filter_max: "Amount up to",
  movements_filter_days: "Days",
  movements_filter_days_placeholder: "Any date",
  movements_filter_rail: "Rail",
  movements_filter_rail_all: "All rails",
  movements_filter_direction: "Direction",
  movements_filter_status: "Payment status",
  movements_filter_status_all: "All statuses",
  movements_filter_incident: "Incident",
  movements_filter_incident_all: "All",
  movements_filter_amount_hint:
    "The amount finds both what moved in the wallet and what reached the beneficiary, before fees.",
  movements_col_when: "Date",
  movements_col_what: "Movement",
  movements_col_amount: "Amount",
  movements_col_incident: "Incident",
  movements_operation_amount_out: "delivered",
  movements_operation_amount_in: "sent",
  movements_breb_qr: "QR payment",
  movements_empty: "No movements",
  movements_empty_filtered: "Try other filters or clear them.",
  movements_total: "{{total}} movements",
  statement_detail_organization: "Organization",
  tx_op_coloca_refund: "Refund",
  entry_coloca_refund_wallet: "Refund from Coloca Payments",
  movements_filter_organization_hint: "Only this organization's movements.",
};
